module.exports = __webpack_public_path__ + "static/media/hyundai-parking-selected.b37db254.svg";